import type { RegisteredPost } from "@/lib/post";

export default {
  __type: "post",
  published: true,
  author: "Zach Garrett",
  title: "Implementing LLM agents with TA concepts",
  tags: ["llm", "agents", "learning"],
  summary:
    "A practical guide for building agents with experiential learning using concepts from TA.",
  posts: {},
} satisfies RegisteredPost;
